import styled from 'styled-components'
import { theme } from 'styles/theme'

import type { NavbarLink as NavbarLinkType } from 'router'

export interface WithIsSidebarOpen {
  isSidebarOpen: boolean
}

interface NavbarLinkProps extends NavbarLinkType, WithIsSelected {}

interface NavbarGroupProps {
  linkGroup: ReadonlyArray<NavbarLinkProps>
}

const StyledNavbarLink = styled.a<WithIsSelected>`
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 4px;
  margin: 0.6em 0;
  padding: 0.65em;
  background-color: ${({ isSelected }) => (isSelected ? theme.colors.LightYellow : 'unset')};
  gap: 1em;
  :hover,
  :focus-visible {
    background-color: ${theme.colors.LightYellow};
  }
  .tooltip {
      display: inline-block;
      position: absolute;
      background-color: ${theme.colors.White};
      padding: 0.6em 0.7em 0.7em 0.7em;
      border-radius: ${theme.radii.tooltipRadii};
      white-space: nowrap;
      left: 100%;
      opacity: 0;
      visibility: hidden;
      font-size: ${theme.fontSizes.medium};
      font-weight: ${theme.fontWeights.bold};
      letter-spacing: .5px;
      z-index: 10;
      filter: drop-shadow(0px 1px 3px rgba(0, 0, 0, 0.2));
      
      &:before {
        content: '';
        display: block;
        position: absolute;
        left: -5px;
        top: 40%;
        
        width: 10px;
        height: 10px;
        transform: rotate(45deg);
        background-color: inherit;
      }
    }
    &:hover {
      background-color: ${theme.colors.MediumGrey};

      .tooltip {
        visibility: visible;
        opacity: 1;
      }
    }  
`

const NavbarLink = ({ text, isSelected, Icon, link }: NavbarLinkProps) => {
  return (
    <StyledNavbarLink {...{ ...link, isSelected }} >
      <Icon />
      <span className="tooltip">{text}</span>
    </StyledNavbarLink>
  )
}

const NavbarLinkGroupContainer = styled.div`
  inline-size: 100%;
  :not(:last-child) {
    border-block-end: solid 1px ${theme.colors.Gray7};
  }
`
const NavbarLinkGroup = ({ linkGroup }: NavbarGroupProps) => (
  <NavbarLinkGroupContainer>
    {linkGroup.map((link, index) => (
      <NavbarLink {...{ key: index, ...link }} />
    ))}
  </NavbarLinkGroupContainer>
)

interface NavbarLinksProps {
  linkGroups: Array<Array<NavbarLinkProps>>
}

const NavbarLinksContainer = styled.div`
  overflow-y: auto;
`
export const NavbarLinks = ({ linkGroups }: NavbarLinksProps) => {
  return (
    <NavbarLinksContainer>
      {linkGroups.map((linkGroup, index) => (
        <NavbarLinkGroup {...{ key: index, linkGroup }} />
      ))}
    </NavbarLinksContainer>
  )
}
